var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyAttendance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 127,
    viewBox: "0 0 208 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5994_87070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104 150C145.421 150 179 116.421 179 75C179 33.5786 145.421 0 104 0C62.5786 0 29 33.5786 29 75C29 116.421 62.5786 150 104 150Z",
    fill: "#F6F7F9"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5994_87070)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 82,
    width: 25.3333,
    height: 44,
    rx: 4,
    fill: "#E8EAEE"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5994_87070)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.333,
    y: 54,
    width: 25.3333,
    height: 72,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_5994_87070)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 118.667,
    y: 35,
    width: 25.3333,
    height: 91,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M82.7625 28.1152C82.7625 28.1152 82.4051 31.6516 79.6191 31.8963C82.4051 32.141 82.7625 35.6774 82.7625 35.6774C82.7625 35.6774 83.1212 32.141 85.9071 31.8963C83.1212 31.6516 82.7625 28.1152 82.7625 28.1152Z",
    fill: "#2E79DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3596 8.13135C47.3596 8.13135 46.9141 12.5316 43.4473 12.836C46.9141 13.1403 47.3596 17.5406 47.3596 17.5406C47.3596 17.5406 47.8052 13.1403 51.2708 12.836C47.8016 12.5316 47.3596 8.13135 47.3596 8.13135Z",
    fill: "#FDC94C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.057 39.1216C23.057 39.1216 22.7269 42.3832 20.1562 42.609C22.7269 42.8348 23.057 46.0964 23.057 46.0964C23.057 46.0964 23.3871 42.8348 25.9564 42.609C23.3871 42.3832 23.057 39.1216 23.057 39.1216Z",
    fill: "#EDEBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.057 39.1216C23.057 39.1216 22.7269 42.3832 20.1562 42.609C22.7269 42.8348 23.057 46.0964 23.057 46.0964C23.057 46.0964 23.3871 42.8348 25.9564 42.609C23.3871 42.3832 23.057 39.1216 23.057 39.1216Z",
    fill: "#D9DDE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.46 94.6328C193.46 94.6328 193.014 99.0331 189.549 99.3374C193.014 99.6418 193.46 104.042 193.46 104.042C193.46 104.042 193.906 99.6418 197.372 99.3374C193.906 99.0331 193.46 94.6328 193.46 94.6328Z",
    fill: "#EDEBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91238 64.126C9.91238 64.126 9.46686 68.5263 6 68.8306C9.46686 69.1349 9.91238 73.5352 9.91238 73.5352C9.91238 73.5352 10.3567 69.1349 13.8236 68.8306C10.3567 68.5263 9.91238 64.126 9.91238 64.126Z",
    fill: "#2E79DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.752 59.4219C198.752 59.4219 198.307 63.8222 194.84 64.1265C198.307 64.4308 198.752 68.8311 198.752 68.8311C198.752 68.8311 199.198 64.4308 202.663 64.1265C199.195 63.8222 198.752 59.4219 198.752 59.4219Z",
    fill: "#2E79DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.595 9C117.595 9 117.149 13.4003 113.684 13.7046C117.149 14.009 117.595 18.4092 117.595 18.4092C117.595 18.4092 118.04 14.009 121.507 13.7046C118.04 13.4003 117.595 9 117.595 9Z",
    fill: "#D9DDE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.956 34.937C175.956 34.937 175.686 38.0592 173.566 38.2755C175.684 38.4919 175.956 41.6154 175.956 41.6154C175.956 41.6154 176.226 38.4919 178.346 38.2755C176.228 38.0592 175.956 34.937 175.956 34.937Z",
    fill: "#FDC94C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5994_87070",
    x: 64,
    y: 78,
    width: 33.333,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5994_87070"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5994_87070",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5994_87070",
    x: 91.333,
    y: 50,
    width: 33.333,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5994_87070"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5994_87070",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_5994_87070",
    x: 112.667,
    y: 25,
    width: 45.333,
    height: 111,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5994_87070"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5994_87070",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5994_87070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 208,
    height: 127,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyAttendance);
export default __webpack_public_path__ + "static/media/empty-attendance.edeca46a.svg";
export { ForwardRef as ReactComponent };